import { Document, Page, pdfjs } from 'react-pdf';
import styles from './index.module.scss';
import BackIcon from './../images/back.svg';
import NextIcon from './../images/next.svg';

// react-pdf v10 dropped the `entry.webpack` builds; the worker is resolved by the
// host bundler instead. Override `pdfjs.GlobalWorkerOptions.workerSrc` to change it.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const isReadableFile = (file) =>
  typeof file === 'string' || file instanceof Blob || file instanceof ArrayBuffer;

const PDFReader = ({ fileReaderInfo, updateFileReaderInfo, onPageChange }) => {
  function onRenderSuccess() {
    const importPDFCanvas = document.querySelector('.import-pdf-page canvas');
    if (!importPDFCanvas) return;

    updateFileReaderInfo({ currentPage: importPDFCanvas.toDataURL() });
  }

  function onDocumentLoadSuccess({ numPages }) {
    updateFileReaderInfo({ totalPages: numPages });
  }

  function changePage(offset) {
    onPageChange(fileReaderInfo.currentPageNumber + offset);
  }

  const nextPage = () => changePage(1);
  const previousPage = () => changePage(-1);

  return (
    <div className={styles.pdfReader}>
      <div className={styles.fileContainer}>
        {isReadableFile(fileReaderInfo.file) && (
          <Document
            className={styles.document}
            file={fileReaderInfo.file}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Page
              className="import-pdf-page"
              onRenderSuccess={onRenderSuccess}
              pageNumber={fileReaderInfo.currentPageNumber}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Document>
        )}
      </div>
      {fileReaderInfo.totalPages > 1 && (
        <div className={styles.pageInfo}>
          <button
            type="button"
            disabled={fileReaderInfo.currentPageNumber <= 1}
            onClick={previousPage}
          >
            <img src={BackIcon} alt="Back" />
          </button>
          <span className={styles.pageInfoDetails}>
            Page&nbsp;<b>{fileReaderInfo.currentPageNumber}</b>&nbsp;of{' '}
            {fileReaderInfo.totalPages || '--'}
          </span>
          <button
            type="button"
            disabled={fileReaderInfo.currentPageNumber >= fileReaderInfo.totalPages}
            onClick={nextPage}
          >
            <img src={NextIcon} alt="Next" />
          </button>
        </div>
      )}
    </div>
  );
};

export default PDFReader;
